<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { create } from '@/routes/hearing-assessment';

defineProps<{
    content: Record<string, string | null>;
}>();
</script>

<template>
    <section class="bg-white px-4 pt-8 pb-16 md:px-20 md:pb-24">
        <div
            class="mx-auto flex max-w-[1208px] flex-col gap-[30px] md:flex-row md:items-center md:gap-10 lg:gap-20"
        >
            <!-- Image -->
            <div>
                <img
                    src="/images/landing/content-section.webp"
                    alt="Pete, a Resonate subscriber, standing in a boxing ring"
                    class="w-full rounded-lg object-cover md:h-[372px] md:w-[598px]"
                />
            </div>

            <!-- Description -->
            <div class="flex flex-col gap-[30px] md:w-[530px]">
                <h2
                    class="font-serif text-[32px] leading-[44.8px] text-primary md:text-[45px] md:leading-[52.8px]"
                >
                    {{ content['content.heading'] }}
                </h2>

                <div class="text-base leading-6 text-primary">
                    <p>{{ content['content.paragraph_1'] }}</p>
                    <p class="mt-2">{{ content['content.paragraph_2'] }}</p>
                </div>

                <Link
                    :href="create().url"
                    class="inline-flex h-[58px] w-full items-center justify-center rounded-full bg-accent text-base font-medium text-accent-foreground transition-opacity hover:opacity-90 md:w-[314px]"
                >
                    {{ content['content.cta_label'] }}
                </Link>
            </div>
        </div>
    </section>
</template>
